import { render, staticRenderFns } from "./ReserveTagSelector.vue?vue&type=template&id=a217b346&scoped=true"
import script from "./ReserveTagSelector.vue?vue&type=script&lang=js"
export * from "./ReserveTagSelector.vue?vue&type=script&lang=js"
import style0 from "./ReserveTagSelector.vue?vue&type=style&index=0&id=a217b346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a217b346",
  null
  
)

export default component.exports